const FINANCIAL_RISK_SCORE_DEFINITION =
  "The Risk Score works on a scale of 1-100 and predicts the likelihood that a business's payment performance will become seriously delinquent, defined as 90-plus days beyond terms within the next 12 months or that the business will go bankrupt.";

export default FINANCIAL_RISK_SCORE_DEFINITION;
